

export function processRequest (filters) {
  var updatedFilters = (filters || []).map(filter => {
    var property = filter.property;
    var operator = filter.operator;
    var value = filter.value;

    if (filter.property.type === 'ASSET') {
      value = (filter.value || []).map(item => {
        if (typeof item === 'string' || item instanceof String) {
          return item;
        }

        return item.id;
      });
    }

    return {
      property: property,
      operator: operator,
      value: value
    }
  }).filter(item => item.value);

  return updatedFilters;
}